import React from "react";
import { Link } from "react-router-dom";
import Icon from "components/AppIcon";

export default function SuccessMessage({ email, onRetry }) {
  return (
    <div className="text-center py-2">
      <div className="relative w-20 h-20 mx-auto mb-6">
        <div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-ping opacity-30" />
        <div className="relative w-20 h-20 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
          <Icon name="MailCheck" size={36} color="#10b981" />
        </div>
      </div>

      <h2 className="text-xl font-bold text-white font-heading mb-2">
        Check your inbox
      </h2>
      <p className="text-slate-400 text-sm font-body mb-1">
        A reset link has been sent to
      </p>
      <p className="text-teal-400 font-semibold text-sm font-caption mb-4 break-all">
        {email}
      </p>

      <div className="bg-teal-500/5 border border-teal-500/15 rounded-xl p-4 mb-6 text-left">
        <p className="text-xs text-slate-400 font-body leading-relaxed">
          <span className="text-teal-400 font-medium">Tip:</span> The link expires in 1 hour. If you don't see the email, check your spam or junk folder.
        </p>
      </div>

      <div className="space-y-3">
        <Link
          to="/login-page"
          className="w-full h-11 rounded-xl bg-primary hover:bg-primary/90 text-white font-semibold text-sm font-caption transition-all duration-200 flex items-center justify-center gap-2 shadow-lg shadow-teal-900/30"
        >
          <Icon name="ArrowLeft" size={16} />
          Back to Login
        </Link>
        <button
          onClick={onRetry}
          className="w-full h-10 rounded-xl border border-white/10 hover:border-white/20 text-slate-400 hover:text-white text-sm font-caption transition-all duration-200"
        >
          Try a different email
        </button>
      </div>
    </div>
  );
}
